import React from 'react';
import type { Candidate } from '@axiom/validation';
import { FocusAreaBars, useApi } from '@axiom/ui';

import { CandidateProfileTopFocusAreasApi } from '../../api/candidate-profile-top-focus-areas-api';
import { TaxonomyApi } from '../../api/taxonomy-api';
import HorizontalRule from '../HorizontalRule/HorizontalRule';

export type TalentProfileDetailTopFocusAreasProps = {
  candidateId: Candidate['id'];
  name?: string;
};

export const TalentProfileDetailTopFocusAreas = ({
  candidateId,
  name = 'TALENT_PROFILE_DETAIL_TOP_FOCUS_AREAS',
}: TalentProfileDetailTopFocusAreasProps) => {
  const [{ data: topFocusAreas }, { data: taxonomy }] = useApi(
    CandidateProfileTopFocusAreasApi.readProfileTopFocusAreas(candidateId),
    TaxonomyApi.readTaxonomy()
  );

  const focusAreas = topFocusAreas.topFocusAreas.map(fa => {
    return {
      ...fa,
      name: taxonomy.focusAreas[fa.focusArea]?.fullName ?? 'Other',
    };
  });

  if (topFocusAreas.topFocusAreas.length === 0) {
    return null;
  }

  return (
    <div data-test={name}>
      <HorizontalRule />
      <FocusAreaBars
        title="Top focus areas"
        subtitle="Talent has identified these as their top focus areas."
        focusAreas={focusAreas}
        background="gray"
        condensed
      />
    </div>
  );
};
